import { combineReducers, configureStore } from '@reduxjs/toolkit';
import userReducer from './user/userSlice.js';
import cartReducer from './cart/cartSlice.js';
import historyReducer from './cart/historySlice.js';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const persistConfig = {
  key: 'root',   //name that we are going to save in the local storage
  version: 1,
  storage,
};

const rootReducer = combineReducers({ 
  user: userReducer,
  cart: cartReducer,
  history: historyReducer
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: getDefaultMiddleware => getDefaultMiddleware({
    serializableCheck: false,
  }),
});

export const persistor = persistStore(store);